export default "__VITE_ASSET__Me6JTUjt__"